import {User} from '@app/modules/shared/models';

export interface IAuthenticationState {
  user: User;
  forgetPassword: any;
  resetPassword: any;
  passwordContext: any;
  success: string;
  error: string;
  authFlow: any;
  impersonating: boolean;
}

const storedUser = localStorage.getItem('currentUser');
const userInstance = storedUser ? Object.assign(new User(), JSON.parse(storedUser)) : null;
if (userInstance?.token) {
  delete userInstance.token;
  localStorage.setItem('currentUser', JSON.stringify(userInstance));
}

export const initialAuthenticationState: IAuthenticationState = {
  user: userInstance,
  forgetPassword: null,
  resetPassword: null,
  passwordContext: null,
  success: '',
  error: '',
  authFlow: null,
  // From the stored session, so a hard reload shows who is being impersonated at once
  // rather than after /auth/refresh answers.
  impersonating: !!userInstance?.impersonation?.active
};
